export default {
    parts: [
        'cartItemRemovedNoticeWrapper',
        'cartItemRemovedNoticeHeader',
        'cartItemRemovedNoticeTitleRow',
        'cartItemRemovedNoticeInfoIcon',
        'cartItemRemovedNoticeEyebrow',
        'cartItemRemovedNoticeCloseButton',
        'cartItemRemovedNoticeCloseIcon',
        'cartItemRemovedNoticeWrapperCompact',
        'cartItemRemovedNoticeHeaderWithClose',
        'cartItemRemovedNoticeHeaderWithoutClose',
        'cartItemRemovedNoticeHeaderCompact',
        'cartItemRemovedNoticeHeading',
        'cartItemRemovedNoticeBody',
        'cartItemRemovedNoticeProductText',
        'bodyGeneralContainer',
        'categoryBlock',
        'categoryTitle',
        'categorySummaryRow',
        'categoryActionButton',
        'toggleTileButton',
        'detailsBody',
        'detailsItem',
        'content',
        'body',
        'header',
        'title',
        'closeButton'
    ],
    baseStyle: {
        cartItemRemovedNoticeWrapper: {
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            color: 'webTypo.textPrimary',
            p: 4,
            mb: 8
        },
        cartItemRemovedNoticeWrapperCompact: {
            p: 3,
            mb: 0
        },
        cartItemRemovedNoticeHeader: {
            alignItems: 'center',
            mb: 6
        },
        cartItemRemovedNoticeHeaderWithClose: {
            justifyContent: 'space-between'
        },
        cartItemRemovedNoticeHeaderWithoutClose: {
            justifyContent: 'flex-start'
        },
        cartItemRemovedNoticeHeaderCompact: {
            mb: 3
        },
        cartItemRemovedNoticeTitleRow: {
            alignItems: 'center',
            gap: 2
        },
        cartItemRemovedNoticeInfoIcon: {
            boxSize: 5,
            color: 'webTypo.textPrimary'
        },
        cartItemRemovedNoticeEyebrow: {
            textStyle: 'labelXs'
        },
        cartItemRemovedNoticeCloseButton: {
            variant: 'ghost',
            minW: 'auto',
            h: 'auto',
            p: 0
        },
        cartItemRemovedNoticeCloseIcon: {
            boxSize: 6,
            color: 'webTypo.textPrimary'
        },
        cartItemRemovedNoticeHeading: {
            textStyle: 'webH4',
            mb: 3
        },
        cartItemRemovedNoticeBody: {
            textStyle: 'bodyXsRegular'
        },
        cartItemRemovedNoticeProductText: {
            textStyle: 'bodyXsBold'
        },
        categoryBlock: {
            mb: 0
        },
        categoryTitle: {
            textStyle: 'webH4',
            mb: 3
        },
        categorySummaryRow: {
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap'
        },
        categoryActionButton: {
            textStyle: 'bodyXsRegular',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'underline'
        },
        toggleTileButton: {
            textStyle: 'bodyXsRegular',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'underline',
            mt: 6
        },
        bodyGeneralContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        detailsBody: {
            p: '24px 16px'
        },
        detailsItem: {
            textStyle: 'bodyXsRegular',
            mb: 6
        },
        content: {
            position: 'fixed',
            top: '0',
            right: '0',
            maxWidth: '448px',
            height: '100vh',
            boxShadow: 'lg',
            borderRadius: 0,
            m: 0,
            color: 'webTypo.textPrimary'
        },
        body: {
            margin: 'auto',
            p: 0,
            width: '100%',
            overflowY: 'auto'
        },
        header: {
            align: 'center',
            justify: 'space-between',
            top: '0',
            zIndex: '1',
            p: {base: 4, lg: 4},
            right: {base: 0},
            maxWidth: {md: '448px'},
            background: 'white',
            w: '100%',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        },
        title: {
            textStyle: 'webH3'
        },
        closeButton: {
            variant: 'ghost',
            size: 'sm',
            background: 'transparent',
            _hover: {background: 'transparent'}
        }
    }
}
